export default {"src":"/_next/static/media/character-a.colour.7ed37c55.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};